itsoftApp.createModule("social", function () {
    const module = this;

    /**
     * Ключ в localStorage, под которым храним айди статей, которые пользователь уже лайкнул.
     * Значение — простой объект-словарь вида { "3": true, "12": true }.
     * localStorage переживает перезагрузку страницы, закрытие вкладки и перезапуск браузера,
     * поэтому годится и для "новой сессии" из ТЗ.
     */
    const STORAGE_KEY = "helinorm:likedArticles";

    const getLikedArticles = function () {
        try {
            const raw = window.localStorage.getItem(STORAGE_KEY);
            if (!raw) return {};
            const parsed = JSON.parse(raw);
            return (parsed && typeof parsed === "object" && !Array.isArray(parsed)) ? parsed : {};
        } catch (e) {
            /* localStorage может быть недоступен (private mode, ITP, политики и т.п.) —
               работаем без персистентности, не падаем. */
            return {};
        }
    };

    const saveLikedArticles = function (liked) {
        try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(liked));
        } catch (e) {
            /* нет доступа к localStorage — просто пропускаем запись */
        }
    };

    const isArticleLiked = function (articleId) {
        if (!articleId) return false;
        return Boolean(getLikedArticles()[articleId]);
    };

    const setArticleLiked = function (articleId, isLiked) {
        if (!articleId) return;
        const liked = getLikedArticles();
        if (isLiked) {
            liked[articleId] = true;
        } else {
            delete liked[articleId];
        }
        saveLikedArticles(liked);
    };

    /**
     * Резолвим идентификатор статьи. Бэкенд может отдать его в нескольких видах:
     *   - data-id="3"      (основной вариант, как сейчас в шаблоне)
     *   - id="3"           (если разметка сделана по-другому)
     *   - data-article-id  (на всякий случай — полезно для устойчивости к доработкам бэка)
     * Пустые строки и пробелы считаем "не задан". Возвращаем строку или null.
     *
     * Важно: отсутствие id — это намеренный сигнал бэкенда «эта статья
     * уже лайкнута пользователем, повторный запрос делать не нужно».
     * Кнопке в таком случае надо просто оставаться активной.
     */
    const resolveArticleId = function (likeButton) {
        const candidates = [
            likeButton.getAttribute("data-id"),
            likeButton.getAttribute("data-article-id"),
            likeButton.getAttribute("id")
        ];

        for (let i = 0; i < candidates.length; i++) {
            const raw = candidates[i];
            if (raw === null || raw === undefined) continue;
            const trimmed = String(raw).trim();
            if (trimmed === "" || trimmed === "0") continue;
            return trimmed;
        }

        return null;
    };

    /**
     * Внутри лайк-кнопки лежит <span class="button__text">{count}</span> (см. include/views/button-main.php).
     * Берём именно его — чтобы поправить только число и не зацепить иконку.
     */
    const getCountElement = function (likeButton) {
        return likeButton.querySelector(".button__text");
    };

    /**
     * Все «зеркала» счётчика, которые держим в синхроне с кнопкой.
     * Сейчас это в первую очередь ярлычок с количеством лайков в шапке статьи —
     * <span class="card-publication__tag-text js-like-count" data-id="…">.
     *
     * Привязываем зеркало к статье через data-id, чтобы при нескольких статьях
     * на одной странице (карточки в подборках и т.п.) счётчики чужих статей
     * не перекинулись из-за нашего клика. Если у зеркала data-id не задан,
     * считаем его «общим» и обновляем безусловно.
     */
    const getMirrorCountElements = function (articleId) {
        const all = document.querySelectorAll(".js-like-count");
        const matched = [];
        Array.prototype.forEach.call(all, function (el) {
            const mirrorId = el.getAttribute("data-id");
            if (!mirrorId || String(mirrorId).trim() === "") {
                matched.push(el);
            } else if (articleId && String(mirrorId).trim() === String(articleId)) {
                matched.push(el);
            }
        });
        return matched;
    };

    const NBSP = String.fromCharCode(0x00A0);

    const parseCount = function (text) {
        /* На бэке цифра может прийти отформатированной (пробелы-разделители тысяч,
           неразрывные пробелы), поэтому перед parseInt чистим всю пробельную окрошку. */
        const raw = (text || "0").split(NBSP).join("").replace(/\s+/g, "");
        const value = parseInt(raw, 10);
        return Number.isFinite(value) ? value : 0;
    };

    const readCount = function (likeButton) {
        const countEl = getCountElement(likeButton);
        if (!countEl) return 0;
        return parseCount(countEl.textContent);
    };

    const writeCount = function (likeButton, value, articleId) {
        const safeValue = Math.max(0, value);
        const stringValue = String(safeValue);

        const countEl = getCountElement(likeButton);
        if (countEl) {
            countEl.textContent = stringValue;
        }

        /* Параллельно обновляем все зеркала (например, ярлычок с количеством лайков
           в шапке статьи), чтобы цифры везде совпадали. */
        const mirrors = getMirrorCountElements(articleId);
        Array.prototype.forEach.call(mirrors, function (mirror) {
            mirror.textContent = stringValue;
        });
    };

    const bumpLikeCount = function (likeButton, delta, articleId) {
        writeCount(likeButton, readCount(likeButton) + delta, articleId);
    };

    const init = function () {
        const yaShareTrigger = document.querySelector(".ya-share-trigger");

        if (yaShareTrigger) {
            const yaShare = document.querySelector(".ya-share2");

            const scriptShr = document.createElement('script');

            scriptShr.setAttribute('src','https://yastatic.net/share2/share.js',);

            scriptShr.setAttribute('async', '');

            itsoftApp.modules.pageLoad.addEvent(function () {
                setTimeout(() => {
                    document.body.appendChild(scriptShr);
                }, 3000);
            })
        }

        const isJsonString = function (str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        const changeLikeCount = function (response) {
            let parseResponse = null;

            if (isJsonString(response)) {
                parseResponse = JSON.parse(response);
            }
        }

        /**
         * sendRequest принимает onSuccess / onError, чтобы вызывающий код
         * мог менять UI только после реального ответа сервера.
         * Поддерживаем диапазон 2xx, не только строгое 200.
         */
        const sendRequest = function (url, onSuccess, onError) {
            const xhr = new XMLHttpRequest();

            xhr.addEventListener("load", function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    changeLikeCount(xhr.response);
                    if (typeof onSuccess === "function") {
                        onSuccess(xhr.response);
                    }
                } else {
                    DEBUG && console.log(xhr.response, ' xhr.response ERROR');
                    if (typeof onError === "function") {
                        onError("Сервер вернул статус " + xhr.status);
                    }
                }
            });

            xhr.addEventListener("error", function () {
                if (typeof onError === "function") {
                    onError("Произошла ошибка соединения");
                } else {
                    DEBUG && console.log("Произошла ошибка соединения");
                }
            });

            xhr.addEventListener("timeout", function () {
                if (typeof onError === "function") {
                    onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
                } else {
                    DEBUG && console.log("Запрос не успел выполниться за " + xhr.timeout + "мс");
                }
            });

            xhr.timeout = 10000;

            xhr.open("GET", url);
            // xhr.open("POST", url);
            xhr.send();
        }

        /* На странице потенциально может быть больше одной лайк-кнопки
           (карточки в подборках и т.п.), поэтому пробегаемся по всем .js-like. */
        const likeButtons = document.querySelectorAll(".js-like");

        Array.prototype.forEach.call(likeButtons, function (likeButton) {
            /* Защита от повторной инициализации: модуль social вызывается через lazy-script
               (см. lazyLoading.js), и при некоторых сценариях init может прилететь повторно. */
            if (likeButton.dataset.likeBound === "true") {
                return;
            }
            likeButton.dataset.likeBound = "true";

            const action = likeButton.getAttribute("data-url");
            const articleId = resolveArticleId(likeButton);

            /* Кнопка считается «уже лайкнутой» в двух эквивалентных случаях:
                 1) бэкенд не прислал id (явный сигнал «эта статья уже лайкнута»);
                 2) у нас есть id, и он лежит в localStorage (мы сами лайкали раньше).
               В обоих случаях стартовое состояние — is-active. */
            const startsActive = !articleId || isArticleLiked(articleId);

            if (startsActive) {
                likeButton.classList.add("is-active");
            }

            /**
             * Применение лайка: класс + счётчик (на кнопке и во всех зеркалах) + persist.
             * Лайк у нас односторонний (поставил — не снять), поэтому функция всегда
             * именно АКТИВИРУЕТ кнопку. Вызывается только после успешного ответа сервера
             * (или сразу, если бэка нет вообще) — чтобы UI и серверное состояние
             * не разъезжались при ошибках сети.
             */
            const applyLike = function () {
                likeButton.classList.add("is-active");
                bumpLikeCount(likeButton, +1, articleId);
                if (articleId) {
                    setArticleLiked(articleId, true);
                }
            };

            likeButton.addEventListener("click", function (evt) {
                evt.preventDefault();

                /* Если кнопка уже активна — пользователь (или бэкенд) считает,
                   что лайк уже стоит. Никаких запросов и изменений UI: тихо выходим. */
                if (likeButton.classList.contains("is-active")) {
                    return;
                }

                /* Защита от двойных кликов: пока запрос в полёте, новые игнорируем,
                   иначе можно поставить лайк дважды и развалить счётчик. */
                if (likeButton.dataset.likeRequestPending === "true") {
                    return;
                }

                let url = "?";
                url += "like" + "=" + true;

                /* id добавляем в query только если он есть, чтобы не отправлять "id=null"
                   и не путать бэкенд пустыми параметрами. */
                if (articleId) {
                    url += "&" + "id" + "=" + encodeURIComponent(articleId);
                }

                if (!action) {
                    /* data-url не задан — никуда стучаться нельзя.
                       Применяем визуально, чтобы интерфейс хоть как-то реагировал на клик.
                       На сервер ничего не уходит, но локальное состояние сохранится в localStorage. */
                    applyLike();
                    return;
                }

                likeButton.dataset.likeRequestPending = "true";
                /* Класс is-loading — необязательный крючок для CSS-стейта (не критично, если стилей нет). */
                likeButton.classList.add("is-loading");

                sendRequest(
                    action + url,
                    function () {
                        applyLike();
                        likeButton.classList.remove("is-loading");
                        likeButton.dataset.likeRequestPending = "false";
                    },
                    function (errorMessage) {
                        DEBUG && console.log("Не удалось обновить лайк:", errorMessage);
                        likeButton.classList.remove("is-loading");
                        likeButton.dataset.likeRequestPending = "false";
                        /* Намеренно НЕ меняем UI: считаем, что серверное состояние
                           важнее, чем оптимистичное предположение клиента. */
                    }
                );
            });
        });
    }

    module.init = init;
});
